import { Frequency } from './frequency.model';

export class Ingredient {
  public id: number;
  public alias: string;
  public name: string;
  public dates: string[] = [];
  public values: number[] = [];
  public minDate: string;
  public maxDate: string;
  public range: string;
  public historical_values = {};
  public frequency: Frequency;

  constructor(name: string) {
    this.name = name;
  }

  // initialize fund parsed CSV file data
  initFromParsedCSVData(dataList: any[]): string {
    dataList.forEach(
      (elem) => {
        try {
          const value: number = +elem[this.name];
          this.dates.push(elem.date);
          this.values.push(value);
          this.historical_values[elem.date as string] = value;
        } catch (error) {
          // The value cnnot be converted to number
          // It is skipped
        }
      }
    );
    this.minDate = this.dates[0];
    this.maxDate = this.dates[0];
    this.dates.forEach(
      (date: string) => {
        if (date < this.minDate) {
          this.minDate = date;
        } else if (date > this.maxDate) {
          this.maxDate = date;
        }
      }
    );
    this.range = this.minDate+' — '+this.maxDate;
    
    const nbYears:number = +this.maxDate.split('-')[0] - +this.minDate.split('-')[0] + 1,
          nbDates:number = this.dates.length;
    if (nbDates<=nbYears) {
      return 'y';
    } else if (nbDates<=4*nbYears) {
      return 'q';
    } else if (nbDates<=12*nbYears) {
      return 'm';
    } else if (nbDates<=52*nbYears) {
      return 'w';
    } else {
      return 'd';
    }
  }

}